import { ReactNode } from 'react'
import {
  COLOR_PALETTE,
  COLOR_PALETTE_BLUE,
  COLOR_PALETTE_GREEN,
  COLOR_PALETTE_LEVEL_2,
  COLOR_PALETTE_LEVEL_3,
  COLOR_PALETTE_MAP,
  PREFERRED_COLOR_PALETTE,
} from '../../Dashboard/colors'

export const colorSchemes = {
  1: COLOR_PALETTE_BLUE,
  2: COLOR_PALETTE_GREEN,
  3: COLOR_PALETTE_LEVEL_2,
  4: COLOR_PALETTE_LEVEL_3,
  5: COLOR_PALETTE_MAP,
  6: PREFERRED_COLOR_PALETTE,
  7: COLOR_PALETTE,
}

export type Step = {
  id: number
  name: string
  component: ReactNode
  preview?: ReactNode
}

export type ChartType = 'line' | 'bar'
//   | 'bar-horizontal'
//   | 'bar-vertical'
//   | 'bar-stacked'

export type DataType =
  | 'spend-per-month-by-tag-ids'
  | 'vendors-per-month-by-tag-ids'
  | 'transactions-per-month-by-tag-ids'
  | 'total-spend-by-vendor'
  | 'total-spend-by-tag-category'

export type ParamType = 'tags' | 'vendors' | 'tag_categories'

export type Selectable = {
  id: number
  name: string
}

export type CustomChart = {
  dataType: DataType
  chartType: ChartType
  items: Selectable[]
  colorScheme: string
}

export type CustomChartState = Partial<CustomChart> & {
  current: number
  name: string
  description: string
  showModal: boolean
  selectedTagCategory?: Selectable | null
}

export type TimeSeriesPayload = {
  tag_id: number
  tag_name?: string
  tag?: string
  data: {
    month: string
    total?: number
    amount?: number
  }[]
}[]

export type SpendSeriesPayload = {
  amount: number
  vendor?: {
    id: number
    name: string
    territory: {
      id: number
      name: string
    }
  }
  category?: {
    id: number
    name: string
  }
}[]
